<script>
var timing = null
var resend = null
var firstLoginKey=false
export default {
	timing, //刷新登录状态
	resend, //自动发送任务
	firstLoginKey //首次登录强制改密标记
}
</script>


// WEBPACK FOOTER //
// src/Global.vue